import React, { useState, useEffect } from 'react';
import { MakeAxiosRequest } from "../../utils/handler";
import Loader from '../../Components/loader/Loader';
import Breadcrumbs from "../../Components/Breadcrumbs/Breadcrumbs";
import { useBreadcrumb } from "../../Components/Breadcrumbs/BreadcrumbContext";
import { useNavigate, useParams } from 'react-router-dom';
import { SwalConfirm, SwalError, SwalSuccess } from '../../Components/SwalFns';
import { useLocation } from "react-router-dom";
import ModalBox from '../../Components/modals/ModalBox';
import loaderFile   from '../../Assets/Images/loader.gif';
function InvoiceDetails({ showModal, handleClose, invoiceKey,url,shareUrl }) {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isResend, setIsResend] = useState(0);
  const [isDraft, setIsDraft] = useState(0);
  const { setBreadcrumbsData } = useBreadcrumb();
  const [showLoader, setShowLoader] = useState(false);


  // const updateBreadcrumbs = () => {
  //   setBreadcrumbsData([
  //     { label: "Invoice", path: "/invoices" },
  //     { label: "Details" },
  //   ]);
  // };
  const fetchData = async () => {

    try {
      const res = await MakeAxiosRequest("post", "/invoice/status", { invoice_uuid: invoiceKey });
      // console.log(response)
      if (res.status == 1) {
        // setIsLoading(false);
        setIsResend(res.isResend);
        setIsDraft(res.is_draft);
      } else {
        console.log(res);
      }
    } catch (error) {
      console.error("Error", error);
    }
  }


  const apiUrl = url; 
  useEffect(() => {
    fetchData();
    // updateBreadcrumbs();
  }, []);

  const resend = () => {
    SwalConfirm({
      title: "Confirmation",
      subText: "Are you sure you want to resend this invoice?",
      successFn: resendInvoice
    });
  }

  const editInvoice = async () =>{

    navigate('/invoices/edit/'+invoiceKey)
  }


  const shareInvoice = async () => {
    
    const urlToCopy = shareUrl;
    try {
      await navigator.clipboard.writeText(urlToCopy);
      SwalSuccess({msg:"URL copied to clipboard!"});
    } catch (error) {
      console.error("Failed to copy: ", error);
      alert("Failed to copy URL.");
    }
  };
  const redirection = async () => {

    navigate('/settings');
  }
  const resendInvoice = async () => {
    try {

      const response = await MakeAxiosRequest("post", "/invoice/resend", { invoice_uuid: invoiceKey });
      // console.log(response);
      if (response.status == 1) {
        SwalSuccess({ msg: response.message });
        shareUrl= response.data.invoiceUrl;
      } else if (response.status == 0) {
          SwalConfirm({
            title: "Confirmation",
            subText: response.message,
            successFn: ()=>redirection(),
          });
        }  else {
        // setError('phone_number', { type: 'custom', message: response.message });
        console.log(response.message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  const downloadInvoice = async (key) => {
    setShowLoader(true);
    try {
      const response = await MakeAxiosRequest("post", "/invoice/download", { invoice_uuid: invoiceKey });

      if (response.status === 1) {
        if (response.data.base64Content) {
          // Create a Blob from the base64 string
          const byteCharacters = atob(response.data.base64Content);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });

          // Create a download link
          const link = document.createElement('a');
          const url = window.URL.createObjectURL(blob);
          link.href = url;
          link.setAttribute('download', response.data.invoiceNum + '.pdf'); // Customize the file name here
          document.body.appendChild(link);
          link.click();

          // Clean up
          link.remove();
          window.URL.revokeObjectURL(url);
          console.log('downloaded');
          setShowLoader(false);
        }
      } else {
        console.log(response);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };


  return (
    // <>
    //   {isLoading ? (
    //     <Loader />
    //   ) : (

    <>
      <ModalBox
        isShow={showModal}
        handleClose={handleClose}
        className="close-btn"
        modalSize="lg"
        hasData={true}
      >
        <form>
          <h3>Invoice Details</h3>

          <div style={{ display: isLoading ? 'block' : 'none', justifyContent: 'center', alignItems: 'center', height: '74vh' }}>
            <Loader />
          </div>

          <div style={{ width: '100%',height: '74vh', display: isLoading ? 'none' : 'block' }}>
            <iframe
              src={apiUrl}
              style={{ width: '100%', height: '100%', border: 'none' }}
              onLoad={() => setIsLoading(false)}
            />
          </div>
          <div className="btnAlignBox justify-content-center mt-2 mt-lg-4">
            {!isLoading && <><a href="javascript:void(0)" className="d-flex align-items-center btn btn-dwnld" onClick={shareInvoice}><span class="material-symbols-outlined me-1"> share </span> Share</a> {isResend == 1 && <a href="javascript:void(0)" class="btn btn-white btn-resend" onClick={resend}>Resend</a>}
             {isDraft =='1' && <a href="javascript:void(0)" className="d-flex align-items-center btn btn-dwnld" onClick={editInvoice}><span class="material-symbols-outlined me-1"> edit </span> Edit Invoice</a>} <a href="javascript:void(0)" className="d-flex align-items-center btn btn-dwnld" onClick={downloadInvoice}><span class="material-symbols-outlined me-1"> download </span> Download</a></>}
          </div>

        </form>
      </ModalBox>
      <ModalBox
                isShow={showLoader}
                className="close-btn "
                modalSize="md"
                hasData={true}
            >    
                <div className='download-sec'>
                    <div>
                        <img className="" src={loaderFile} alt="Loading..." />
                        <h5 className='mt-4 gray'>Downloading...</h5>
                    </div>
                </div>   
               
                    
            </ModalBox>
      {/* <div className="row">
            <div className="col-sm-10 col-lg-7">
              <Breadcrumbs />
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12">
                      <div class="row d-flex align-items-center flex-wrap ">
                        <div class="col-xl-6 mb-3">
                          <div class="d-flex justify-content-center justify-content-xl-start">
                            <h4>Invoice</h4>
                          </div>
                        </div>
                        <div class="col-xl-6 mb-3">
                          <div class="btn_align d-flex justify-content-xl-end justify-content-center">
                          {!isLoading && <> {isResend == 1 && <a href="javascript:void(0)" class="btn btn-white btn-resend" onClick={resend}>Resend</a>}
                          <a href="javascript:void(0)" class="d-flex align-items-center btn btn-dwnld" onClick={downloadInvoice}><span class="material-symbols-outlined me-1"> download </span> Download</a></>}
                          </div>
                        </div>
                      </div>
                    </div>
                    {isLoading && (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                          <Loader/>
                        </div>
                      )}
                    <div style={{ width: '100%', height: '100vh',display: isLoading ? 'none' : 'block' }}>
                      <iframe
                        src={apiUrl}
                        style={{ width: '100%', height: '100%', border: 'none' }}
                        onLoad={() => setIsLoading(false)}
                      />
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

    </>
    //   )}
    // </>
  )
}

export default InvoiceDetails